export default __webpack_public_path__ + "static/media/cancel.b0f6101f.svg";